export default __webpack_public_path__ + "static/media/early_prototype3.f97d3a83.jpeg";